import styled, { createGlobalStyle, css } from "styled-components";
import { reset, device } from "common/src/styles/Reset";
import { MEDIA_URL } from "static-content/RelativeUrlHelperFunctions";
import theme from "styled-theming";

const clientCustomDiv = theme("client", {
  bbva: css`
    @media ${device.laptop} {
      display: inline-block;
      width: ${(props) => (!props.userProfile ? "500px" : "600px")};
      height: ${(props) => (!props.userProfile ? "350px" : "450px")};
      background-image: ${(props) =>
        !props.userProfile
          ? `url(${MEDIA_URL}/branding/rightBg.png)`
          : `url(${MEDIA_URL}/branding/rightBg_${props.userProfile}.png)`};
      background-size: contain;
      background-repeat: no-repeat;
      position: absolute;
      top: ${(props) => (!props.userProfile ? "80px" : "auto")};
      bottom: ${(props) => (!props.userProfile ? "auto" : "15.5%")};
      right: ${(props) => (!props.userProfile ? "-150px" : "-260px")};
    }
  `,
});

const clientBg = theme("client", {
  bbva: css`
    background-image: none;
    @media ${device.laptop} {
      background-color: #cce8f7;
      &::before {
        content: "";
        display: inline-block;
        width: 100%;
        height: 100%;
        background-image: ${(props) =>
          `url(${MEDIA_URL}/branding/pageBg${!props.userProfile ? "" : `_${props.userProfile}`}.png)`};
        background-repeat: no-repeat;
        background-position: 0 100%;
        background-size: 25%;
        z-index: 1;
        position: absolute;
        top: 0;
        left: 0;
      }
      &::after {
        content: "";
        display: inline-block;
        width: 100%;
        height: 16%;
        background-color: #01396c;
        position: absolute;
        bottom: 0;
        right: 0;
        z-index: -1;
      }
    }
  `,
});

const clientWrapper = theme("client", {
  bbva: css`
    @media ${device.laptop} {
      padding-top: 30px;
      border: 30px solid #206cab;
      max-height: 73%;
      position: absolute;
      bottom: 0;
      right: 0;
      left: 0;
      padding-bottom: 20px;
      &::after {
        content: "";
        display: inline-block;
        width: 200px;
        height: 150px;
        background-image: url(${MEDIA_URL}/branding/clip.png);
        background-size: contain;
        background-repeat: no-repeat;
        position: absolute;
        top: -120px;
        right: 0;
        left: 0;
        margin: 0 auto;
      }
    }
  `,
});

export const AppWrapper = styled.div`
  position: relative;
  text-align: center;
  min-height: 550px;
  height: 100vh;
`;

export const Wrapper = styled.div`
  height: 100%;
  margin: 0 auto;
  max-width: 550px;
  padding: 20px 10px;
  padding-bottom: 120px;
  background: #fff;
  padding-top: ${(props) => (props.topbar ? "50px" : "20px")};
  z-index: 50;
  @media ${device.laptop} {
    padding-top: ${(props) => (props.topbar ? "100px" : "20px")};
  }
  ${clientWrapper}
`;

export const CustomizableDiv = styled.div`
  ${clientCustomDiv}
`;

export const GlobalStyle = createGlobalStyle`
  ${reset};
  body,html {overflow:hidden;height:auto !important}
  body {
  font-family:${(props) => `${props.theme.themeGlobal.font}, 'Trebuchet MS', sans-serif`};
  font-size: 17px;
  font-size: 1.7rem;
  color: #383737;
  color:${(props) => props.theme.themeGlobal.textColor};
  background-image: url(${MEDIA_URL}/branding/pageBg.png);
  background-size: 55%;
  background-color: #fff;
  background-color: ${(props) => props.theme.themeGlobal.bgApp};
  ${clientBg};
}

h1,h2,h3{font-size: 18px;
  font-size: 1.8rem;
  padding: 15px 0;
  margin: 0;
  color: #555586;
  color: ${(props) => props.theme.themeGlobal.headingColor};
  }
  h2{padding: 20px;}

  button {
    border-radius: ${(props) => props.theme.themeGlobal.borderRadiusSecondary};
    font-weight: bold;
    padding: 15px 10px;
    border: 0;
  }
  
  button.readMore,
  button.readLess {
  padding: 5px 5px 3px 10px;
  color: ${(props) => props.theme.themeGlobal.main};
  background-image: url(../returns/calendar/rb-arrow-right-b.png);
  background-color: transparent;
  background-repeat: no-repeat;
  background-size: 4px;
  background-position: 2px 9px;
  margin-left: 10px;
  cursor: pointer;
  float: right;
  width: 100%;
  text-align: right;
  }
.thumb.thumbY {
background:${(props) => props.theme.main} !important;
}
.disabledLink{pointer-events:none}
a:link,a:visited,a:hover,a:active{text-decoration:none}
.optanon-alert-box-wrapper.hide-accept-button {display:none !important;}
`;
